import { isValidElement } from 'react';

import { CheckboxGroup } from '../CheckboxGroup';
import { RadioGroup } from '../RadioGroup';
import { Select } from '../Select';
import { Switch } from '../Switch';
import { TextInput } from '../TextInput';
import { TextInputGhost } from '../TextInputGhost';
import { TextInputLiner } from '../TextInputLiner';

import type { ReactElement, ReactNode } from 'react';
import type { CheckboxGroupProps } from '../CheckboxGroup';
import type { RadioGroupProps } from '../RadioGroup';
import type { SelectProps } from '../Select';
import type { SwitchProps } from '../Switch';
import type { TextInputProps } from '../TextInput';
import type { TextInputGhostProps } from '../TextInputGhost';
import type { TextInputLinerProps } from '../TextInputLiner';

type TextInputLikeElement =
  | ReactElement<TextInputProps, typeof TextInput>
  | ReactElement<TextInputLinerProps, typeof TextInputLiner>
  | ReactElement<TextInputGhostProps, typeof TextInputGhost>;

export const isTextInputLike = (element: ReactNode): element is TextInputLikeElement => {
  if (!isValidElement(element)) return false;
  return (
    element.type === TextInput || element.type === TextInputLiner || element.type === TextInputGhost
  );
};

export const isSelect = (
  element: ReactNode,
): element is ReactElement<SelectProps, typeof Select> => {
  if (!isValidElement(element)) return false;
  return element.type === Select;
};

export const isRadioGroup = (
  element: ReactNode,
): element is ReactElement<RadioGroupProps, typeof RadioGroup> => {
  if (!isValidElement(element)) return false;
  return element.type === RadioGroup;
};

export const isCheckboxGroup = (
  element: ReactNode,
): element is ReactElement<CheckboxGroupProps, typeof CheckboxGroup> => {
  if (!isValidElement(element)) return false;
  return element.type === CheckboxGroup;
};

export const isSwitch = (
  element: ReactNode,
): element is ReactElement<SwitchProps, typeof Switch> => {
  if (!isValidElement(element)) return false;
  return element.type === Switch;
};
